import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpRoutingModule } from './help-routing.module';
import { HelpPageComponent } from './help-page/help-page.component';

@NgModule({
  imports: [
    CommonModule,
    HelpRoutingModule
  ],
  declarations: [HelpPageComponent]
})
export class HelpModule { }



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/help/help.module.ts